/** Lightweight hover tooltip. Uses aria-label on the child for a11y. */
export default function Tip({ label, children, side = 'bottom' }) {
  if (!label) return children;
  return (
    <span className={`tip tip--${side}`} data-tip={label}>
      {children}
    </span>
  );
}
